module.exports = __webpack_public_path__ + "media/images/plans/propose_restaurant/dinner-course-photo-1-1-69b4a595fb2e9bfb7a763e8215f4c712.jpg";